import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../utils/const";
import DeleteUserButton from "./DeleteButton";

const EmployeeList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");

  useEffect(() => {
    setLoading(true);
    setError(null);

    apiClient
      .post("/adminuser.php", { action: "getUsers" })
      .then((res) => {
        const data = res.data;
        
        if (data.message === 'radha') {
          setUsers(Array.isArray(data.data.users) ? data.data.users : []);
        } else {
          setError(data.message || "Failed to fetch users");
        }
      })      
      .catch((err) => {
        console.error("API Error:", err);
        setError("Network error");
      })
      .finally(() => setLoading(false));
  }, []);

  const handleAcceptUser = (userId, userName) => {
    setSelectedUserId(userId);
    setSelectedUserName(userName);
    setShowConfirmModal(true);
  };

  const confirmAcceptUser = () => {
    if (!selectedUserId) return;

    apiClient
      .post("/adminuser.php", {
        action: "updateUserType",
        id: selectedUserId,
        usertype: 1,
      })
      .then((res) => {
        const data = res.data;
        if (data.success) {
          setUsers((prev) =>
            prev.map((u) =>
              u.id === selectedUserId ? { ...u, usertype: 1 } : u
            )
          );
        } else {
          alert(data.message || "Failed to update user type.");
        }
      })
      .catch(() => alert("Network error while updating user type."))
      .finally(() => {
        setShowConfirmModal(false);
        setSelectedUserId(null);
        setSelectedUserName("");
      });
  };

  const cancelAcceptUser = () => {
    setShowConfirmModal(false);
    setSelectedUserId(null);
    setSelectedUserName("");
  };

  const filteredUsers = users.filter(
    (user) =>
      (user.name && user.name.toLowerCase().includes(search.toLowerCase())) ||
      (user.email && user.email.toLowerCase().includes(search.toLowerCase())) ||
      (user.phone && user.phone.toLowerCase().includes(search.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredUsers.length / entriesPerPage) || 1;
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  // Utility functions for role and status (handle string/number)
  const getRole = (usertype) =>
    String(usertype) === "2"
      ? "Admin"
      : String(usertype) === "1"
        ? "Employee"
        : "Pending";
        
  const getStatus = (status) =>
    String(status) === "1" ? "Active" : "Inactive";

  return (
    <div className="page-wrapper">
      {showConfirmModal && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "24px",
              maxWidth: "400px",
              width: "90%",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            }}
          >
            <div
              className="header"
              style={{
                borderBottom: "1px solid #4B2C3B",
                paddingBottom: "18px",
                marginBottom: "18px",
              }}
            >
              <h3
                className="title"
                style={{
                  margin: 0,
                  color: "white",
                  backgroundColor: "#4B2C3B",
                }}
              >
                Confirm Action
              </h3>
            </div>
            <div className="modal-body" style={{ marginBottom: "20px" }}>
              <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                Do you want to accept <strong>{selectedUserName}</strong> as an
                employee?
              </p>
            </div>
            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                onClick={cancelAcceptUser}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  backgroundColor: "white",
                  color: "#6c757d",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button
                onClick={confirmAcceptUser}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #4B2C3B",
                  borderRadius: "4px",
                  backgroundColor: "#4B2C3B",
                  color: "white",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="page-content">
        <div className="container-xxl">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="row align-items-center">
                    <div className="col">
                      <h1
                        className="card-title"
                        style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                      >
                        Employee Details
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div
                    className="d-flex justify-content-between align-items-center mb-3"
                    style={{ marginTop: "1rem" }}
                  >
                    <div>
                      <select
                        value={entriesPerPage}
                        onChange={(e) => {
                          setEntriesPerPage(Number(e.target.value));
                          setCurrentPage(1);
                        }}
                        className="form-select d-inline-block w-auto"
                      >
                        {[5, 10, 20, 50].map((num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        ))}
                      </select>
                      <span className="ms-2">entries per page</span>
                    </div>
                    <input
                      type="text"
                      className="form-control w-auto"
                      placeholder="Search"
                      value={search}
                      onChange={(e) => {
                        setSearch(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ minWidth: 200 }}
                    />
                  </div>
                  <div className="table-responsive">
                    {loading ? (
                      <div className="text-center p-4">Loading...</div>
                    ) : error ? (
                      <div className="alert alert-danger m-3">{error}</div>
                    ) : (
                      <>
                        <table
                          className="table mb-0 align-middle"
                          id="datatable_1"
                        >
                          <thead className="table-light">
                            <tr>
                              <th className="text-center px-3 py-3 border-0">ID</th>
                              <th className="text-start px-3 py-3 border-0">Name</th>
                              <th className="text-center px-3 py-3 border-0">Phone</th>
                              <th className="text-center px-3 py-3 border-0">Role</th>
                              <th className="text-center px-3 py-3 border-0">Status</th>
                              <th className="text-center px-3 py-3 border-0">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedUsers.length > 0 ? (
                              paginatedUsers.map((user, idx) => (
                                <tr
                                  key={user.id || idx}
                                  className="border-bottom"
                                  style={{
                                    borderBottom: "1px solid var(--bs-border-color)",
                                    transition: "all 0.3s ease",
                                    backgroundColor: idx % 2 === 0 ? "transparent" : "var(--bs-gray-50)",
                                  }}
                                  onMouseEnter={(e) => {
                                    const tr = e.target.closest("tr");
                                    tr.style.backgroundColor = "var(--bs-primary-bg-subtle)";
                                    tr.style.transform = "translateY(-1px)";
                                    tr.style.boxShadow = "0 4px 20px rgba(0,0,0,0.1)";
                                  }}
                                  onMouseLeave={(e) => {
                                    const tr = e.target.closest("tr");
                                    const idx = Array.from(tr.parentNode.children).indexOf(tr);
                                    tr.style.backgroundColor = idx % 2 === 0 ? "transparent" : "var(--bs-gray-50)";
                                    tr.style.transform = "translateY(0px)";
                                    tr.style.boxShadow = "none";
                                  }}
                                >
                                  {/* ID Column */}
                                  <td className="text-center px-3 py-3 border-0">
                                    <span
                                      className="badge bg-primary bg-gradient px-2 py-1"
                                      style={{
                                        fontSize: "0.8rem",
                                        fontWeight: "600",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      #{user.id}
                                    </span>
                                  </td>

                                  {/* Name Column */}
                                  <td className="text-start px-3 py-3 border-0">
                                    <div>
                                      <h6
                                        className="mb-0 fw-semibold"
                                        style={{
                                          fontSize: "0.95rem",
                                          color: "var(--bs-body-color)",
                                        }}
                                      >
                                        {user.name}
                                      </h6>
                                      <small
                                        className="text-muted"
                                        style={{
                                          fontSize: "0.8rem",
                                          color: "#e0b200",
                                        }}
                                      >
                                        {user.email}
                                      </small>
                                    </div>
                                  </td>

                                  {/* Phone Column */}
                                  <td className="text-center px-3 py-3 border-0">
                                    <span
                                      className="fw-medium"
                                      style={{
                                        fontSize: "0.9rem",
                                        color: "var(--bs-secondary-color)",
                                      }}
                                    >
                                      {user.phone}
                                    </span>
                                  </td>

                                  {/* Role Column */}
                                  <td className="text-center px-3 py-3 border-0">
                                    <span
                                      className={`badge px-3 py-2 ${
                                        getRole(user.usertype) === "Admin"
                                          ? "bg-danger bg-gradient"
                                          : getRole(user.usertype) === "Employee"
                                          ? "bg-success bg-gradient"
                                          : "bg-warning bg-gradient text-dark"
                                      }`}
                                      style={{
                                        fontSize: "0.8rem",
                                        fontWeight: "600",
                                        borderRadius: "12px",
                                      }}
                                    >
                                      {getRole(user.usertype)}
                                    </span>
                                  </td>

                                  {/* Status Column */}
                                  <td className="text-center px-3 py-3 border-0">
                                    <span
                                      className={`badge px-3 py-2 ${
                                        String(user.status) === "1"
                                          ? "bg-success bg-gradient"
                                          : "bg-secondary bg-gradient"
                                      }`}
                                      style={{
                                        fontSize: "0.8rem",
                                        fontWeight: "600",
                                        borderRadius: "12px",
                                      }}
                                    >
                                      {getStatus(user.status)}
                                    </span>
                                  </td>

                                  {/* Actions Column */}
                                  <td className="text-center px-3 py-3 border-0">
                                    <div className="btn-group" role="group">
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm me-1"
                                        title="Edit Permissions"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          navigate(`/permission/${user.id}`);
                                        }}
                                        style={{
                                          borderRadius: "8px",
                                          padding: "6px 12px",
                                          transition: "all 0.2s ease",
                                          border: "1px solid #667eea",
                                          color: "#667eea",
                                          backgroundColor: "transparent",
                                        }}
                                        onMouseEnter={(e) => {
                                          e.currentTarget.style.backgroundColor = "#667eea";
                                          e.currentTarget.style.color = "white";
                                          e.currentTarget.style.transform = "translateY(-1px)";
                                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(102, 126, 234, 0.3)";
                                        }}
                                        onMouseLeave={(e) => {
                                          e.currentTarget.style.backgroundColor = "transparent";
                                          e.currentTarget.style.color = "#667eea";
                                          e.currentTarget.style.transform = "translateY(0px)";
                                          e.currentTarget.style.boxShadow = "none";
                                        }}
                                      >
                                        <i className="fas fa-edit" style={{ fontSize: "0.8rem" }}></i>
                                      </button>

                                      <DeleteUserButton
                                        userId={user.id}
                                        userName={user.name}
                                        onDeleteSuccess={(deletedId) =>
                                          setUsers((prev) =>
                                            prev.filter((u) => u.id !== deletedId)
                                          )
                                        }
                                      />

                                      {(user.usertype === 0 || user.usertype === "0") && (
                                        <button
                                          type="button"
                                          className="btn btn-outline-success btn-sm"
                                          title="Accept User"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handleAcceptUser(user.id, user.name);
                                          }}
                                          style={{
                                            borderRadius: "8px",
                                            padding: "6px 12px",
                                            transition: "all 0.2s ease",
                                            border: "1px solid #28a745",
                                            color: "#28a745",
                                            backgroundColor: "transparent",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor = "#28a745";
                                            e.currentTarget.style.color = "white";
                                            e.currentTarget.style.transform = "translateY(-1px)";
                                            e.currentTarget.style.boxShadow = "0 4px 12px rgba(40, 167, 69, 0.3)";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor = "transparent";
                                            e.currentTarget.style.color = "#28a745";
                                            e.currentTarget.style.transform = "translateY(0px)";
                                            e.currentTarget.style.boxShadow = "none";
                                          }}
                                        >
                                          <i className="fas fa-check" style={{ fontSize: "0.8rem" }}></i>
                                        </button>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center p-4">
                                  No users found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>

                  {!loading && !error && filteredUsers.length > 0 && (
                    <div className="d-flex justify-content-center align-items-center mt-3">
                      <button
                        className="btn btn-outline-secondary btn-sm me-2"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                      >
                        Prev
                      </button>
                      <span>
                        Page {currentPage} of {totalPages}
                      </span>
                      <button
                        className="btn btn-outline-secondary btn-sm ms-2"
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage(currentPage + 1)}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeList;